import { createContext, useContext } from "react";

const BotConfigContext = createContext(null);

export function BotConfigProvider({ value, children }) {
  return (
    <BotConfigContext.Provider value={value}>
      {children}
    </BotConfigContext.Provider>
  );
}

export function useBotConfig() {
  return useContext(BotConfigContext);
}